import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";

interface ProfileCreationCardsProps {
  onSmartCreate: () => void;
}

const ProfileCreationCards: React.FC<ProfileCreationCardsProps> = ({
  onSmartCreate,
}) => {
  return (
    <Row className="g-4 mb-5">
      {/* [2026-02-13] Maya: Center card on tablet (md) and desktop (lg) */}
      <Col md={8} lg={6} className="offset-md-2 offset-lg-3">
        <Card className="h-100 profile-creation-card" onClick={onSmartCreate}>
          <Card.Body className="p-4">
            <div className="text-center">
              {/* Icon */}
              <div className="mb-3 profile-creation-icon profile-creation-icon-smart">
                <FontAwesomeIcon icon={faLightbulb} className="profile-creation-icon-inner" />
              </div>

              {/* Title and Subtitle */}
              <h4 className="mb-2 text-color-black fw-600">Smart Filters</h4>
              <p className="text-muted mb-3 u-P3-14">
                Easy guided setup for simplified alert creation.
              </p>

              {/* Features List */}
              <ul className="text-start mb-4 profile-creation-list">
                <li className="mb-2 profile-creation-list-item">✓ Step-by-step guided setup</li>
                <li className="mb-2 profile-creation-list-item">
                  ✓ Category and keyword filtering
                </li>
                <li className="mb-2 profile-creation-list-item">
                  ✓ Manufacturer and country filters
                </li>
                <li className="mb-2 profile-creation-list-item">✓ Auto-generated profile names</li>
              </ul>

              {/* Action Button */}
              <Button
                variant="primary"
                size="sm"
                className="profile-creation-btn profile-creation-btn-smart"
              >
                Create Smart Profile
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default ProfileCreationCards;
